import { Grid, ButtonGroup, Button } from '@material-ui/core';
import React, { useEffect, useMemo, useState } from 'react';

import GijgoGrid from '../../../Core/Controls/GijgoGrid';
import { BreadCrumbs, EditButton, formatters } from '../../../Core/Controls';
import { AppStorage } from '../../../Core/Basic/storage-service';
import { useLocation } from 'react-router-dom';
import ReactDOM from 'react-dom';
import { useHistory } from 'react-router-dom';

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

const crumbs = [
    { name: 'Home', path: '/' },
    { name: 'Contracts', path: '/', active: true }
];

const baseColumns = [
    { key: 'regNo', name: 'Reg No', width: 40 },
    { key: 'startDate', name: 'Start Date', formatter: formatters.Date_DDMMYYYY, width: 40 },
    { key: 'endDate', name: 'End Date', formatter: formatters.Date_DDMMYYYY, width: 40 },
    { key: 'serviceAgentName', name: 'Service Area', width: 80 },
    { key: 'contractType', name: 'Contract Type', width: 80 },
    { key: 'status', name: 'Status', width: 80 }
];

const ContractList = () => {
    const history = useHistory();

    const query = useQuery();
    const statusParam = query.get('status');
    const contractTypeParam = query.get('contractType');

    useEffect(() => {
        const filterKey = '/contractVehicles'; // Change this if your route is different
        const existingFilters = JSON.parse(localStorage.getItem('_GijgoFiltterParams_') || '{}');

        // Only update if params exist
        if (statusParam || contractTypeParam) {
            existingFilters[filterKey] = {
                ...(existingFilters[filterKey] || {}),
                ...(statusParam ? { status: statusParam } : {}),
                ...(contractTypeParam ? { contractType: contractTypeParam } : {})
            };

            localStorage.setItem('_GijgoFiltterParams_', JSON.stringify(existingFilters));
        }
    }, [statusParam, contractTypeParam]);

    const reDirectToVehicleDash = (rowData) => {
        history.push({
            pathname: `/controller/editVehicle/${rowData.contractVehicleID}`,
            search: `?redirectLabel=Contract`
        });
    };

    const renderRegNo = ({ row, col }, grid) => {
        const spn = document.createElement('span');
        const lnk = (
            <div style={{ cursor: 'pointer', fontWeight: 'bold' }} onClick={() => reDirectToVehicleDash(row)}>
                {row.regNo}
            </div>
        );
        ReactDOM.render(lnk, spn);
        return spn;
    };

    const columns = useMemo(() => {
        const tempCols = [...baseColumns];
        let regNoCol = tempCols.find((element) => element.key === 'regNo');
        if (regNoCol) {
            regNoCol.formatter = renderRegNo;
        }
        return tempCols;
    }, []);

    let getUrl = `Contracts/Contract_List`;
    // ${
    //     statusParam || contractTypeParam
    //         ? `?${statusParam ? `status=${encodeURIComponent(statusParam)}` : ''}${statusParam && contractTypeParam ? '&' : ''}${
    //               contractTypeParam ? `contractType=${encodeURIComponent(contractTypeParam)}` : ''
    //           }`
    //         : ''}
    return (
        <div className="screen">
            <Grid container>
                <Grid container justify="space-between">
                    <Grid item>
                        <BreadCrumbs crumbs={crumbs} className="edit-Customer-btn" />
                    </Grid>
                </Grid>
                <GijgoGrid
                    dataConverter={(res) => ({
                        records: res.data.list,
                        total: res.data.total
                    })}
                    columns={columns}
                    getUrl={getUrl}
                    // isReload={state.isReload}

                    // mapBtnToolTipTitle={mapBtnTitle}
                    // mapBtnIcon={RoomIcon}
                    // mapBtnLabel={mapBtnTitle}
                    // onMapBtnClick={handleShowLocation}
                />
            </Grid>
            {/* {state.showModal ? (
                <DialogComp title={'Contract'} onClose={() => handleClose(false)} maxWidth="lg" fullWidth>
                    <ContractEditModal onClose={handleClose} selectedRecord={state.selectedRecord || {}} />
                </DialogComp>
            ) : null} */}
        </div>
    );
};
export default ContractList;
